export const VALUES = {
  ghostUser: {
    displayName: 'Ghost',
    login: 'ghost',
    avatarUrl: 'https://avatars.githubusercontent.com/ghost',
    path: '/ghost',
    url: '/ghost',
  },
}
